import { Apple, Mail } from "lucide-react";
import { BrandLockup } from "@/components/BrandLockup";
import { copy } from "@/content/explordioCopy";

const DEVICES = "https://static.prod-images.emergentagent.com/jobs/299b8c53-46da-401d-aeb3-6cb3ef120270/images/506d89ae3223b2737277fcd77c5f4604c218eb73f66b098a78e1f98a6b2ac1e2.jpeg";

const StoreButton = ({ type }) => (
  <button type="button" className="store-button" aria-label={`${copy.stores.prefix} ${copy.stores[type]}`} data-testid={`${type}-store-placeholder-button`}>
    {type === "google" ? <span className="play-mark" aria-hidden="true" /> : <Apple size={36} fill="white" aria-hidden="true" />}
    <span>
      <span className="store-small" data-testid={`${type}-store-prefix`}>{copy.stores.prefix}</span>
      <span className="store-large" data-testid={`${type}-store-name`}>{copy.stores[type]}</span>
    </span>
  </button>
);

export const HeroSection = ({ onContactOpen }) => (
  <header className="hero" data-testid="hero-section">
    <div className="site-shell">
      <nav className="hero-nav" aria-label="Primary navigation" data-testid="primary-navigation">
        <button className="contact-button" type="button" onClick={onContactOpen} data-testid="contact-button">
          <Mail size={25} aria-hidden="true" /> {copy.nav.contact}
        </button>
      </nav>
      <div className="hero-grid">
        <div className="hero-copy">
          <BrandLockup />
          <h1 className="hero-title" data-testid="hero-title">
            {copy.hero.titleLead} <span>{copy.hero.titleAccent}</span>
          </h1>
          <p className="hero-subtitle" data-testid="hero-subtitle">{copy.hero.subtitle}</p>
          <div className="store-row" data-testid="store-buttons-container">
            <StoreButton type="google" />
            <StoreButton type="apple" />
          </div>
        </div>
        <div className="hero-visual" data-testid="hero-device-visual">
          <img className="hero-devices" src={DEVICES} alt="Explordio media library on tablet and phone" data-testid="hero-devices-image" />
        </div>
      </div>
    </div>
  </header>
);